import type { ClientView } from '@gazette/shared';
import { locale, t, tn } from '../../i18n/index.ts';
import { Clipping } from './Clipping.tsx';

/** The whole edition as readable DOM, for the phones that can't read a spinning newspaper. */
export function GazetteSheet({ current, revealed }: { current: ClientView; revealed: boolean }) {
  const gazette = current.gazette;
  if (!gazette) return null;
  const date = new Intl.DateTimeFormat(locale.value, { weekday: 'long', day: 'numeric', month: 'long' }).format(gazette.publishedAt);
  const player = (id: string | undefined) => current.players.find((candidate) => candidate.id === id);
  return (
    <section class="gazette-sheet" aria-label={t('app.name')}>
      <header class="gazette-sheet__masthead">
        <p class="gazette-sheet__title">{t('app.name')}</p>
        <p class="gazette-sheet__motto">{t('gz.motto')}</p>
        <p class="gazette-sheet__info">
          <span>{t('gz.edition', { n: gazette.edition })}</span>
          <span>{date}</span>
          <span>{tn('gz.count', gazette.articles.length)}</span>
        </p>
      </header>
      <div class="gazette-sheet__columns">
        {gazette.articles.map((article) => {
          const verdict = revealed ? current.verdicts.find((candidate) => candidate.articleId === article.id) : undefined;
          return (
            <Clipping
              key={article.id}
              article={article}
              victim={player(article.targetId)}
              verdict={verdict}
              author={player(verdict?.authorId)}
              size="small"
            />
          );
        })}
      </div>
    </section>
  );
}
